var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqDirection = function SvgFaqDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-direction_svg__a)",
    fillRule: "evenodd",
    d: "M27.583 16.446V16c0-6.401-5.193-11.594-11.594-11.594S4.396 9.6 4.396 16v.446-.043c2.079-1.1 3.429-1.644 5.65-2.352A6.4 6.4 0 0 0 9.74 16c0 1.089.283 2.112.762 2.994a56 56 0 0 0-5.356 1.154 11.6 11.6 0 0 0 10.831 7.446c4.943 0 9.155-3.081 10.82-7.425a61 61 0 0 0-5.355-1.154c.49-.892.773-1.915.773-3.004 0-.675-.109-1.317-.305-1.916 2.21.708 3.549 1.241 5.64 2.362zM16 29.38c7.392 0 13.379-5.987 13.379-13.379S23.392 2.621 16 2.621 2.621 8.608 2.621 16 8.608 29.379 16 29.379m0-16.057c-1.48 0-2.678 1.198-2.678 2.678S14.52 18.678 16 18.678s2.678-1.197 2.678-2.678S17.48 13.322 16 13.322M11.537 16A4.46 4.46 0 0 1 16 11.537 4.456 4.456 0 0 1 20.463 16 4.456 4.456 0 0 1 16 20.463 4.456 4.456 0 0 1 11.537 16",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-direction_svg__a",
    x1: 16,
    x2: 16,
    y1: 29.379,
    y2: 2.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgFaqDirection;